import { Inject, Injectable } from '@angular/core';

import { Observable, combineLatest, map, share } from 'rxjs';

import {
    IPlaceButtonActionService,
    IPlaceButtonDisableService,
    IPlaceButtonMessageService,
    IPlaceButtonStateService,
    IPlaceButtonTitleService,
    IPlaceButtonViewModel,
    IPlaceButtonViewModelService,
    PLACE_BUTTON_ACTION_SERVICE,
    PLACE_BUTTON_DISABLE_SERVICE,
    PLACE_BUTTON_MESSAGE_SERVICE,
    PLACE_BUTTON_STATE_SERVICE,
    PLACE_BUTTON_TITLE_SERVICE,
} from '../interfaces/place-button-interfaces';
import { BetslipSelectedPaymentService } from './betslip-place-button-selected-payment.service';

@Injectable()
export class BetslipPlaceButtonViewModelService implements IPlaceButtonViewModelService {
    viewModel$: Observable<IPlaceButtonViewModel>;

    constructor(
        @Inject(PLACE_BUTTON_STATE_SERVICE) placeButtonService: IPlaceButtonStateService,
        @Inject(PLACE_BUTTON_ACTION_SERVICE) actionHandlerService: IPlaceButtonActionService,
        @Inject(PLACE_BUTTON_DISABLE_SERVICE) disableService: IPlaceButtonDisableService,
        @Inject(PLACE_BUTTON_TITLE_SERVICE) titleService: IPlaceButtonTitleService,
        selectedPaymentService: BetslipSelectedPaymentService,
        @Inject(PLACE_BUTTON_MESSAGE_SERVICE) messageService: IPlaceButtonMessageService,
    ) {
        const state$ = placeButtonService.state$;
        const isDisabled$ = disableService.isButtonDisabled$;
        const action$ = actionHandlerService.action$;
        const message$ = messageService.buttonMessage$;
        const title$ = titleService.buttonTitle$;
        const buttonSelectedPayment$ = selectedPaymentService.selectedPayment$;
        this.viewModel$ = combineLatest([state$, action$, isDisabled$, message$, title$, buttonSelectedPayment$]).pipe(
            map(([state, action, isDisabled, message, title, buttonSelectedPayment]) => {
                return {
                    state,
                    action,
                    isDisabled,
                    message,
                    title,
                    selectedPaymentType: buttonSelectedPayment,
                    isProcessing: state.isProcessing,
                };
            }),
            share(),
        );
    }
}
